import React, { useId } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";

import styles from "./save-progress-modal.module.scss";

interface ResumeChoiceModalProps {
  onResume: () => void;
  onStartOver: () => void;
  /** Escape and a backdrop click land here, starting nothing. */
  onDismiss: () => void;
}

function ResumeChoiceModal({
  onResume,
  onStartOver,
  onDismiss,
}: ResumeChoiceModalProps) {
  const { t } = useTranslation(["assessment"]);
  const titleId = useId();

  return (
    <Modal
      isOpen={true}
      toggle={onDismiss}
      style={{ width: "auto", maxWidth: "400px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
      labelledBy={titleId}
      data-testid="resume-choice-modal"
    >
      <ModalBody className={styles["body"]}>
        <h1 id={titleId}>{t("assessment:resumeChoice.title")}</h1>
        <p>{t("assessment:resumeChoice.body")}</p>
      </ModalBody>
      <ModalFooter className={styles["footer"]}>
        <Button variant="enclosed-primary" onClick={onResume}>
          {t("assessment:resumeChoice.resume")}
        </Button>
        <Button variant="ghost" onClick={onStartOver}>
          {t("assessment:resumeChoice.startOver")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ResumeChoiceModal;
